import PropTypes from 'prop-types';
import { Children } from 'react';
// -*- mode: jsx;-*-
import { Svg } from './Svg.js';
import { SHARE_TOOLS, trackShareToolClick } from './shareToolUtils.js';

/* global dcAnalytics */


export const SmsLink = function (props) {
    function onClickEvent(event) {
        dcAnalytics.trackShareToolClick(window.location.pathname, props.urlToShare, 'SMS');
        trackShareToolClick(props.projectId, SHARE_TOOLS.SMS);
        props.onSmsClick(event);
    }
    function getButtonClassName() {
        return props.className || '';
    }
    function getSmsUrl() {
        var text = props.text;
        var link = props.urlToShare;
        return 'sms:?&body=' + text + ' ' + link;
    }
    function shareIcon() {
        if (Children.count(props.children) > 0) {
            return null;
        } else {
            return (
                <Svg icon="chat" attributes={{ 'aria-label': 'share via sms' }}/>
            );
        }
    }
    function isAndroid() {
        return navigator.userAgent.toLowerCase().indexOf('android') > -1;
    }
    if (isAndroid()) {
        return null;
    }
    return (
        <a
            className={getButtonClassName()}
            href={getSmsUrl()}
            onClick={onClickEvent}
            target="_blank"
            rel="noreferrer noopener"
        >
            {shareIcon()}
            {props.children}
        </a>
    );
};

SmsLink.propTypes = {
    text: PropTypes.string.isRequired,
    projectId: PropTypes.number,
    urlToShare: PropTypes.string.isRequired,
    onSmsClick: PropTypes.func.isRequired,
    children: PropTypes.element,
    className: PropTypes.string,
};
